
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AgregarAnexosDemandaInicialParams, AgregarPartesDemandaInicialParams, AgregarConceptosDemandaInicialParams } from '../../interfaces/comun/DemandaInicialInterface';

export const AgregarPartesDemandaInicial = ( params: AgregarPartesDemandaInicialParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/DemandaInicial/AgregarPartes', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const AgregarConceptosDemandaInicial = ( params: AgregarConceptosDemandaInicialParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/DemandaInicial/AgregarConceptos', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const AgregarAnexosDemandaInicial = ( params: AgregarAnexosDemandaInicialParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/DemandaInicial/AgregarAnexos', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}